import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { CompetitionPlayerLog } from "@/modules/competitions/entity";
import QueryPaginator from "@/modules/vue/components/QueryPaginator.vue";
import PlayerLayout from "@/modules/team/pages/players/PlayerLayout.vue";
import CompetitionLogTable from "@/modules/team/pages/players/CompetitionLogTable.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'CompetitionLogs',
  setup(__props) {
    const route = useRoute();
    const query = computed(() => CompetitionPlayerLog.createQueryBuilder('log').innerJoinAndSelect('log.player', 'player').innerJoinAndSelect('log.season', 'season').innerJoinAndSelect('log.competition', 'competition').innerJoinAndSelect('competition.country', 'country').where('player.id = :playerId', {
      playerId: route.params.id
    }).orderBy('season.currentDateRaw', 'DESC'));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PlayerLayout, {
        onUpdated: _cache[0] || (_cache[0] = () => _ctx.$refs.queryPaginator.refresh())
      }, {
        default: _withCtx(() => [_createVNode(QueryPaginator, {
          ref: "queryPaginator",
          query: _unref(query),
          "per-page": 20
        }, {
          default: _withCtx(({
            items
          }) => [_createVNode(CompetitionLogTable, {
            stats: items
          }, null, 8, ["stats"])]),
          _: 1
        }, 8, ["query"])]),
        _: 1
      });
    };
  }
});